export class OperationsAlertObjectInfo {}
